(function () {
  document.documentElement.classList.add('v4-hybrid');
  document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.add('v4-hybrid');

    // Shop Window season pills → hero (unchanged)
    var hero = document.querySelector('[data-v4-hero]');
    if (hero) {
      var title = hero.querySelector('[data-v4-hero-title]');
      var copy = hero.querySelector('[data-v4-hero-copy]');
      var cta = hero.querySelector('[data-v4-hero-cta]');
      var img = hero.querySelector('[data-v4-hero-img]');
      var caption = hero.querySelector('[data-v4-hero-caption]');
      var eyebrow = hero.querySelector('[data-v4-hero-eyebrow]');

      function applySeason(btn) {
        var payload;
        try { payload = JSON.parse(btn.getAttribute('data-v4-season')); } catch (e) { return; }
        document.querySelectorAll('[data-v4-season]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        if (eyebrow) eyebrow.textContent = payload.eyebrow || '';
        if (copy) copy.textContent = payload.copy || '';
        if (cta) {
          cta.href = payload.url || '#';
          cta.textContent = payload.cta || 'Explore looks';
        }
        if (img && payload.image) {
          img.src = payload.image;
          img.alt = payload.label + ' look inspiration';
        }
        if (caption) caption.textContent = payload.caption || '';
      }

      document.querySelectorAll('[data-v4-season]').forEach(function (btn) {
        // Hover and keyboard focus preview the hero. Click is a real link and must navigate.
        btn.addEventListener('mouseenter', function () { applySeason(btn); });
        btn.addEventListener('focus', function () { applySeason(btn); });
      });
    }

    // Intention carousel — horizontal scroll via prev/next
    document.querySelectorAll('[data-v4-mission-carousel]').forEach(function (root) {
      var track = root.querySelector('[data-v4-mission-track]');
      var prev = root.querySelector('[data-v4-mission-prev]');
      var next = root.querySelector('[data-v4-mission-next]');
      if (!track || !prev || !next) return;

      function cardStep() {
        var card = track.querySelector('.v4-mission-card');
        if (!card) return Math.round(track.clientWidth * 0.8);
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 20;
        return Math.round(card.getBoundingClientRect().width + gap);
      }

      function syncDisabled() {
        var max = track.scrollWidth - track.clientWidth - 2;
        prev.disabled = track.scrollLeft <= 2;
        next.disabled = track.scrollLeft >= max;
      }

      prev.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
      next.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
      track.addEventListener('scroll', syncDisabled, { passive: true });
      window.addEventListener('resize', syncDisabled);
      syncDisabled();
    });
  });
})();

/* === V4 PDP BATCH1 BUY NOW === */
(function () {
  function root() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest && e.target.closest('[data-v4-buy-now]');
    if (!btn || btn.disabled) return;
    e.preventDefault();
    var formId = btn.getAttribute('data-product-form');
    var form = (formId && document.getElementById(formId)) || btn.closest('form');
    if (!form) return;
    btn.setAttribute('aria-busy', 'true');
    var fd = new FormData(form);
    // Ensure quantity present
    if (!fd.get('quantity')) {
      var qty = form.querySelector('[name="quantity"]');
      fd.set('quantity', qty && qty.value ? qty.value : '1');
    }
    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd,
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('add_failed');
        return r.json();
      })
      .then(function () {
        window.location.href = root() + 'checkout';
      })
      .catch(function () {
        btn.removeAttribute('aria-busy');
        // Fallback: native submit to cart then user can checkout
        try {
          form.submit();
        } catch (err) {}
      });
  });
})();

/* === V4 PDP BATCH1 DOM ORDER (Founder restore) === */
/* LIVE rhythm: Arrives + promo stay after price (template order).
   Only ensure CTAs sit after options; quantity before CTAs. Never move Arrives after CTAs. */
(function () {
  function directChild(info, el) {
    var n = el;
    while (n && n.parentElement !== info) n = n.parentElement;
    return n;
  }
  function placeBuyColumn() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var actions = info.querySelector('.v4-pdp-actions');
    if (!actions) return;
    var buyWrap = directChild(info, actions);
    if (!buyWrap) return;

    var options =
      info.querySelector('.globo-swatch-product-detail') ||
      info.querySelector('variant-selects') ||
      info.querySelector('.v4-variant-selects') ||
      info.querySelector('.ks-chart-container');
    var optionsChild = options ? directChild(info, options) : null;

    var qty =
      info.querySelector('quantity-input') ||
      info.querySelector('.product-form__quantity') ||
      info.querySelector('[id^="Quantity-Form-"]');
    var qtyChild = qty ? directChild(info, qty) : null;

    // Quantity immediately before CTAs
    if (qtyChild && qtyChild !== buyWrap) {
      buyWrap.before(qtyChild);
    }
    // CTAs after options (and after qty if present)
    if (optionsChild && optionsChild !== buyWrap) {
      var after = optionsChild;
      if (qtyChild && qtyChild.parentElement === info) after = qtyChild;
      if (after.nextSibling !== buyWrap) after.after(buyWrap);
    }

    // Arrives Within — ensure it stays near price (before options), never after CTAs
    var arrives = info.querySelector('.output');
    if (arrives) {
      var arrivesBlock = directChild(info, arrives);
      var price = info.querySelector('[id^="price-"]');
      var priceChild = price ? directChild(info, price) : null;
      if (arrivesBlock && priceChild) {
        var stylePrev = arrivesBlock.previousElementSibling;
        var styleNode = (stylePrev && stylePrev.tagName === 'STYLE' && /output/.test(stylePrev.textContent || '')) ? stylePrev : null;
        // Only relocate if Arrives drifted after CTAs/options
        var arrivesOrder = Array.prototype.indexOf.call(info.children, arrivesBlock);
        var buyOrder = Array.prototype.indexOf.call(info.children, buyWrap);
        var optOrder = optionsChild ? Array.prototype.indexOf.call(info.children, optionsChild) : -1;
        if (buyOrder >= 0 && arrivesOrder > buyOrder) {
          var anchor = priceChild;
          var rule = info.querySelector('.v4-pdp-rule--under-price');
          var ruleChild = rule ? directChild(info, rule) : null;
          if (ruleChild) anchor = ruleChild;
          anchor.after(arrivesBlock);
          if (styleNode) arrivesBlock.before(styleNode);
        } else if (optOrder >= 0 && arrivesOrder > optOrder) {
          var anchor2 = priceChild;
          var rule2 = info.querySelector('.v4-pdp-rule--under-price');
          var ruleChild2 = rule2 ? directChild(info, rule2) : null;
          if (ruleChild2) anchor2 = ruleChild2;
          anchor2.after(arrivesBlock);
          if (styleNode) arrivesBlock.before(styleNode);
        }
      }
    }
  }

  function boot() {
    placeBuyColumn();
    setTimeout(placeBuyColumn, 600);
    setTimeout(placeBuyColumn, 1500);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();


/* === V4 PDP BATCH1 IN-FRAME ZOOM GUARD === */
/* Founder: click zooms inside main frame — never open Craft lightbox/overlay. */
(function () {
  function guardModal() {
    var root = document.querySelector('[data-zoom-on-hover]');
    if (!root) return;
    document.querySelectorAll('product-modal, .product-media-modal').forEach(function (m) {
      try { if (m.hasAttribute('open')) m.removeAttribute('open'); } catch (e) {}
    });
    // Re-bind magnify if script loaded before images swapped
    if (typeof enableZoomOnHover === 'function') {
      try { enableZoomOnHover(2); } catch (e) {}
    } else {
      document.querySelectorAll('.image-magnify-hover').forEach(function (image) {
        if (image.dataset.v4MagnifyBound) return;
        image.dataset.v4MagnifyBound = '1';
        image.addEventListener('click', function (event) {
          // Prefer native magnify if present; else minimal in-frame zoom
          if (typeof magnify === 'function') {
            magnify(image, 2);
            if (typeof moveWithHover === 'function') moveWithHover(image, event, 2);
            return;
          }
          var existing = image.parentElement && image.parentElement.querySelector('.image-magnify-full-size');
          if (existing) { existing.remove(); return; }
          var overlay = document.createElement('div');
          overlay.className = 'image-magnify-full-size';
          overlay.setAttribute('aria-hidden', 'true');
          overlay.style.backgroundImage = "url('" + image.currentSrc + "')";
          overlay.style.backgroundSize = (image.naturalWidth || image.width) * 2 + 'px';
          overlay.style.backgroundPosition = '50% 50%';
          overlay.style.backgroundRepeat = 'no-repeat';
          image.parentElement.insertBefore(overlay, image);
          overlay.addEventListener('click', function () { overlay.remove(); });
          overlay.addEventListener('mousemove', function (ev) {
            var rect = image.getBoundingClientRect();
            var x = ((ev.clientX - rect.left) / rect.width) * 100;
            var y = ((ev.clientY - rect.top) / rect.height) * 100;
            overlay.style.backgroundPosition = x + '% ' + y + '%';
          });
          overlay.addEventListener('mouseleave', function () { overlay.remove(); });
        });
      });
    }
  }
  // Block lightbox open attempts on hover-zoom PDPs
  document.addEventListener('click', function (e) {
    if (!document.querySelector('[data-zoom-on-hover]')) return;
    var toggle = e.target && e.target.closest && e.target.closest('.product__media-toggle, .product__media-icon');
    if (toggle) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, true);
  document.addEventListener('DOMContentLoaded', function () {
    guardModal();
    setTimeout(guardModal, 800);
  });
  // If modal somehow opens, close it
  var obs = new MutationObserver(function () {
    if (!document.querySelector('[data-zoom-on-hover]')) return;
    document.querySelectorAll('product-modal[open], .product-media-modal[open]').forEach(function (m) {
      try { m.removeAttribute('open'); } catch (e) {}
    });
  });
  try { obs.observe(document.documentElement, { subtree: true, attributes: true, attributeFilter: ['open'] }); } catch (e) {}
})();

/* PDP Batch 2 — Trust / policy drawer (URGENT FIX 2026-10-02: close + a11y) */
(function () {
  var TITLES = {
    shipping: 'Shipping',
    returns: 'Returns',
    refunds: 'Refunds',
    why: 'Why Choose Us',
    discreet: 'Discreet packaging'
  };

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () {
    var root = document.querySelector('[data-v4-trust]');
    var drawer = document.querySelector('[data-v4-trust-drawer]');
    if (!root || !drawer) return;

    // Portal drawer to <body> so position:fixed is viewport-true
    if (drawer.parentElement !== document.body) {
      document.body.appendChild(drawer);
    }

    var titleEl = drawer.querySelector('[data-v4-trust-title]');
    var bodyEl = drawer.querySelector('[data-v4-trust-body]');
    var panelEl = drawer.querySelector('[data-v4-trust-panel]');
    var overlayEl = drawer.querySelector('.v4-trust-drawer__overlay');
    var closeBtn = drawer.querySelector('.v4-trust-drawer__close');
    var lastFocus = null;
    var scrollY = 0;
    var touchStartX = null;
    var closing = false;

    function panels() {
      return drawer.querySelectorAll('[data-v4-trust-content]');
    }

    function showPanel(key) {
      panels().forEach(function (p) {
        var on = p.getAttribute('data-v4-trust-content') === key;
        if (on) p.removeAttribute('hidden');
        else p.setAttribute('hidden', '');
      });
      if (titleEl) titleEl.textContent = TITLES[key] || 'Details';
    }

    function focusables() {
      return Array.prototype.slice.call(
        drawer.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])')
      ).filter(function (el) {
        if (el.hasAttribute('disabled')) return false;
        if (el.classList.contains('v4-trust-drawer__overlay')) return false;
        if (el.closest('[hidden]')) return false;
        return true;
      });
    }

    function isOpen() {
      return !drawer.hasAttribute('hidden') && drawer.classList.contains('is-open');
    }

    function lockScroll() {
      scrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add('v4-trust-drawer-open');
      document.body.classList.add('v4-trust-drawer-open');
    }

    function unlockScroll() {
      document.documentElement.classList.remove('v4-trust-drawer-open');
      document.body.classList.remove('v4-trust-drawer-open');
      window.scrollTo(0, scrollY);
    }

    function openDrawer(key) {
      closing = false;
      lastFocus = document.activeElement;
      showPanel(key);
      drawer.removeAttribute('hidden');
      drawer.hidden = false;
      drawer.setAttribute('aria-hidden', 'false');
      void drawer.offsetWidth;
      drawer.classList.add('is-open');
      lockScroll();
      setTimeout(function () {
        if (closeBtn) closeBtn.focus();
        else if (bodyEl) bodyEl.focus();
      }, 30);
    }

    function closeDrawer() {
      if (closing) return;
      if (drawer.hasAttribute('hidden') && !drawer.classList.contains('is-open')) return;
      closing = true;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');

      var done = false;
      var finish = function () {
        if (done) return;
        done = true;
        if (panelEl) panelEl.removeEventListener('transitionend', onEnd);
        drawer.setAttribute('hidden', '');
        drawer.hidden = true;
        unlockScroll();
        closing = false;
        if (lastFocus && typeof lastFocus.focus === 'function') {
          try { lastFocus.focus(); } catch (e) {}
        }
      };
      var onEnd = function (ev) {
        if (ev && ev.target !== panelEl) return;
        if (ev && ev.propertyName && ev.propertyName !== 'transform') return;
        finish();
      };
      if (panelEl) panelEl.addEventListener('transitionend', onEnd);
      // Hard failsafe — always dismiss even if transitionend never fires
      setTimeout(finish, 280);
    }

    function onCloseEvent(e) {
      if (!isOpen() && drawer.hasAttribute('hidden')) return;
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      closeDrawer();
    }

    // Direct bindings (more reliable than only delegated document click)
    if (overlayEl) {
      overlayEl.addEventListener('click', onCloseEvent);
      overlayEl.addEventListener('mousedown', function (e) {
        // mousedown closes even if a later click is swallowed
        if (e.button === 0) onCloseEvent(e);
      });
    }
    if (closeBtn) {
      closeBtn.addEventListener('click', onCloseEvent);
    }

    // Delegated open (root + drawer for "See why choose us")
    document.addEventListener('click', function (e) {
      var openBtn = e.target && e.target.closest && e.target.closest('[data-v4-trust-open]');
      if (openBtn) {
        e.preventDefault();
        openDrawer(openBtn.getAttribute('data-v4-trust-open'));
        return;
      }
      // Fallback close via data attribute (in case direct bind missed)
      var closer = e.target && e.target.closest && e.target.closest('[data-v4-trust-close]');
      if (closer && drawer.contains(closer) && isOpen()) {
        onCloseEvent(e);
      }
    }, true); // capture phase so we win over other handlers

    document.addEventListener('keydown', function (e) {
      if (!isOpen()) return;
      if (e.key === 'Escape' || e.key === 'Esc') {
        onCloseEvent(e);
        return;
      }
      if (e.key !== 'Tab') return;
      var list = focusables();
      if (!list.length) return;
      var first = list[0];
      var last = list[list.length - 1];
      if (e.shiftKey && document.activeElement === first) {
        e.preventDefault();
        last.focus();
      } else if (!e.shiftKey && document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    });

    if (panelEl) {
      panelEl.addEventListener('touchstart', function (e) {
        if (!e.touches || !e.touches[0]) return;
        touchStartX = e.touches[0].clientX;
      }, { passive: true });
      panelEl.addEventListener('touchend', function (e) {
        if (touchStartX == null || !e.changedTouches || !e.changedTouches[0]) return;
        var dx = e.changedTouches[0].clientX - touchStartX;
        touchStartX = null;
        if (dx > 70) closeDrawer();
      }, { passive: true });
    }
  });
})();

/* === PDP FOUNDER POLISH 2026-10-02 — hide leftover policy accordions; discreet ABOVE Secure/SWC === */
(function () {
  var POLICY = /^(our\s+)?shipping\s+policy$|^returns?\s+policy$|^refund\s+policy$|^exclusive\s+shopping\s+benefits$/i;
  var moving = false;

  function hidePolicyAccordions() {
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    info.querySelectorAll('.product__accordion, details.accordion, .accordion').forEach(function (el) {
      var title = el.querySelector('.accordion__title, summary span, summary');
      var text = (title && title.textContent || '').replace(/\s+/g, ' ').trim();
      if (POLICY.test(text)) {
        el.style.display = 'none';
        el.setAttribute('hidden', '');
        el.setAttribute('data-v4-founder-hidden-policy', '1');
      }
    });
  }

  function directChild(info, el) {
    var n = el;
    while (n && n.parentElement && n.parentElement !== info) n = n.parentElement;
    return (n && n.parentElement === info) ? n : null;
  }

  function findByExactText(info, exact) {
    var nodes = info.querySelectorAll('div,p,span,h2,h3,h4,section,header');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      // prefer leaf-ish nodes whose own text matches
      var own = '';
      for (var c = 0; c < el.childNodes.length; c++) {
        if (el.childNodes[c].nodeType === 3) own += el.childNodes[c].textContent;
      }
      own = own.replace(/\s+/g, ' ').trim();
      var full = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (own === exact || full === exact) return el;
    }
    return null;
  }

  function climbBlock(info, el, stopRe) {
    if (!el) return null;
    var block = el;
    for (var up = 0; up < 8 && block.parentElement && block.parentElement !== info; up++) {
      var parent = block.parentElement;
      var pt = (parent.textContent || '').slice(0, 240);
      if (stopRe && stopRe.test(pt) && parent.querySelector('.product-form__submit, .v4-pdp-actions')) break;
      // don't climb into product-form itself
      if (parent.tagName === 'PRODUCT-FORM' || parent.classList.contains('product-form')) break;
      block = parent;
    }
    return block;
  }

  function placeDiscreetStack() {
    if (moving) return;
    var info = document.querySelector('.product__info-container');
    if (!info) return;
    var trust = info.querySelector('.v4-trust');
    if (!trust) return;
    var trustChild = directChild(info, trust);
    if (!trustChild) return;

    var buy = info.querySelector('product-form');
    var buyChild = buy ? directChild(info, buy) : null;
    // buy_buttons outer wrapper often wraps product-form + vitals injects
    var buyWrap = buyChild;
    // Prefer the shopify block wrapper that contains submit
    var submit = info.querySelector('.product-form__submit');
    if (submit) {
      var wrap = directChild(info, submit);
      if (wrap) buyWrap = wrap;
    }

    moving = true;
    try {
      // Find Secure + SWC text nodes
      var secureText = findByExactText(info, 'Secure checkout with your preferred payment method') || findByExactText(info, 'Can I pay the way I want');
      var swcText = findByExactText(info, 'Shop With Confidence');
      var secureBlock = climbBlock(info, secureText, /ADD TO CART|BUY NOW/);
      var swcBlock = climbBlock(info, swcText, null);

      // If Secure is nested under buyWrap, pull it out after trust
      // Desired: buyWrap (ATC/BUY/Pay) → trust → secure → swc/vitals

      // First: ensure trust follows buyWrap
      if (buyWrap && trustChild !== buyWrap) {
        var kids = Array.prototype.slice.call(info.children);
        if (kids.indexOf(trustChild) < kids.indexOf(buyWrap) || (secureBlock && buyWrap.contains(secureBlock) && kids.indexOf(trustChild) > kids.indexOf(buyWrap))) {
          // always place trust right after buyWrap
        }
        buyWrap.after(trustChild);
      }

      // Move Secure after trust (extract from buyWrap if needed)
      if (secureBlock) {
        var secureTop = directChild(info, secureBlock) || secureBlock;
        // If nested inside buyWrap, move the nested block itself after trust
        if (buyWrap && buyWrap.contains(secureBlock) && secureBlock !== buyWrap) {
          trustChild.after(secureBlock);
        } else if (secureTop && secureTop !== trustChild && secureTop !== buyWrap) {
          trustChild.after(secureTop);
        }
      }

      // Move SWC / vitals after secure (or after trust)
      if (swcBlock) {
        var swcTop = directChild(info, swcBlock) || swcBlock;
        var afterEl = trustChild.nextElementSibling;
        // if next looks like secure, put after it
        if (afterEl && secureBlock && (afterEl === secureBlock || afterEl.contains(secureBlock) || (secureText && afterEl.contains(secureText)))) {
          afterEl.after(swcTop);
        } else if (swcTop && swcTop !== trustChild) {
          trustChild.after(swcTop);
        }
      }
      try { if (window.__v4CompressPayTrust) window.__v4CompressPayTrust(); } catch (e) {}
    } finally {
      moving = false;
    }
  }

  function boot() {
    hidePolicyAccordions();
    placeDiscreetStack();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  setTimeout(boot, 600);
  setTimeout(boot, 1500);
  setTimeout(boot, 3000);
})();

/* === FOUNDER FIX3 (2026-10-02) — Kiwi restore + Arrives ship row === */
(function () {
  var TRUCK_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
    '<path d="M3 7h11v10H3V7zm11 3h4l3 3v4h-7v-7z"/>' +
    '<circle cx="7" cy="18" r="2"/><circle cx="17" cy="18" r="2"/>' +
    '</svg>';

  function arrivesRange(raw) {
    var compact = String(raw || '').replace(/\s+/g, ' ').trim();
    var m = compact.match(/(\d{1,2})(?:\s+([A-Za-z]{3}))?\s*[–\-]\s*(\d{1,2})(?:\s+([A-Za-z]{3}))?/);
    if (!m) return '';
    function cap(mon) {
      if (!mon) return '';
      return mon.charAt(0).toUpperCase() + mon.slice(1).toLowerCase();
    }
    var d1 = String(parseInt(m[1], 10));
    var mon1 = cap(m[2] || '');
    var d2 = String(parseInt(m[3], 10));
    var mon2 = cap(m[4] || '');
    var left = mon1 || mon2;
    var right = mon2 || mon1;
    if (!left || !right) return '';
    return d1 + ' ' + left + '-' + d2 + ' ' + right;
  }

  function enhanceArrives() {
    var outputs = document.querySelectorAll('.product__info-container .output');
    outputs.forEach(function (el) {
      if (el.dataset.v4ArrivesEnhanced === '1') return;
      var raw = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (!/arrives/i.test(raw)) return;
      var range = arrivesRange(raw);
      if (!range) return;
      el.dataset.v4ArrivesEnhanced = '1';
      el.classList.add('v4-arrives-bar');
      var shipSrc = el.querySelector('.v4-arrives-ship');
      var shipLabel = (shipSrc && shipSrc.textContent.replace(/\s+/g, ' ').trim()) || 'Free UK Shipping';
      shipLabel = shipLabel.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
      el.innerHTML =
        '<span class="v4-arrives-ship">' + TRUCK_SVG + '<span>' + shipLabel + '</span></span>' +
        '<span class="v4-arrives-dates">Arrives ' + range + '</span>';
    });
  }

  function findGloboSizeLegend() {
    var root = document.querySelector('.globo-swatch-product-detail');
    if (!root) return null;
    var byData = root.querySelector('.name-option[data-name="Size"], .name-option[data-name="size"]');
    if (byData) return byData;
    var legends = root.querySelectorAll('.name-option, legend.name-option');
    for (var i = 0; i < legends.length; i++) {
      var n = (legends[i].getAttribute('data-name') || legends[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (/^size\b/i.test(n) || n.toLowerCase() === 'size') return legends[i];
    }
    return null;
  }

  function findGloboColourLegend() {
    var root = document.querySelector('.globo-swatch-product-detail');
    if (!root) return null;
    var byData = root.querySelector('.name-option[data-name="Color"], .name-option[data-name="Colour"], .name-option[data-name="color"], .name-option[data-name="colour"]');
    if (byData) return byData;
    var legends = root.querySelectorAll('.name-option');
    for (var i = 0; i < legends.length; i++) {
      var n = (legends[i].getAttribute('data-name') || '').toLowerCase();
      if (n === 'color' || n === 'colour') return legends[i];
    }
    return null;
  }

  function restoreKiwi() {
    var ks =
      document.querySelector('.ks-chart-container') ||
      document.querySelector('.sizing-chart-container');
    if (!ks) return;

    var sizeLegend = findGloboSizeLegend();
    if (!sizeLegend) return;

    sizeLegend.classList.add('v4-globo-size-label');
    if (!sizeLegend.contains(ks)) {
      sizeLegend.appendChild(ks);
    }
    ks.dataset.v4KiwiRestored = '1';
    ks.classList.add('v4-kiwi-in-globo');

    var colourLegend = findGloboColourLegend();
    if (colourLegend && colourLegend.dataset.v4ColourReady !== '1') {
      colourLegend.classList.add('v4-globo-colour-label');
      var selectedSpan = colourLegend.querySelector('.name-variant') || colourLegend.querySelector('.v4-colour-selected');
      if (!selectedSpan) {
        selectedSpan = document.createElement('span');
        selectedSpan.className = 'name-variant v4-colour-selected';
        colourLegend.appendChild(selectedSpan);
      } else {
        selectedSpan.classList.add('v4-colour-selected');
      }
      // 9 Oct 2026 go-live fix: read the colour group's own option index (Size is often option 0, Colour option 1); it was hard-coded to 0 so the Colour row showed the size letter.
      var v4CIdx = '0';
      try { var v4Grp = colourLegend.closest('.swatch--gl'); if (v4Grp && v4Grp.getAttribute('data-option-index') !== null) v4CIdx = v4Grp.getAttribute('data-option-index'); } catch (e) {}
      function syncColour() {
        var root = document.querySelector('.globo-swatch-product-detail');
        if (!root) return;
        var r = root.querySelector('input[name="globo-option-' + v4CIdx + '"]:checked') ||
                root.querySelector('.swatch--gl[data-option-index="' + v4CIdx + '"] input[type="radio"]:checked');
        var val = r ? (r.value || r.getAttribute('value') || '') : '';
        if (!val) {
          var li = root.querySelector('.swatch--gl[data-option-index="' + v4CIdx + '"] li.select-option.selected') ||
                   root.querySelector('.swatch--gl[data-option-index="' + v4CIdx + '"] li.select-option.available') ||
                   root.querySelector('.swatch--gl[data-option-index="' + v4CIdx + '"] li.select-option');
          if (li) val = li.getAttribute('data-value') || '';
        }
        selectedSpan.textContent = val || '';
      }
      syncColour();
      setTimeout(syncColour, 300);
      setTimeout(syncColour, 1200);
      document.addEventListener('change', function (e) {
        if (e.target && String(e.target.name || '').indexOf('globo-option') === 0) syncColour();
      });
      document.addEventListener('click', function (e) {
        if (e.target && e.target.closest && e.target.closest('.swatch--gl[data-option-index="0"]')) {
          setTimeout(syncColour, 40);
        }
      });
      colourLegend.dataset.v4ColourReady = '1';
    }

    document.querySelectorAll('variant-selects .v4-size-label-row, variant-selects .v4-colour-label-row').forEach(function (row) {
      try { row.remove(); } catch (e) {}
    });
  }

  function bootFix3() {
    try { enhanceArrives(); } catch (e) {}
    try { restoreKiwi(); } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bootFix3);
  else bootFix3();
  setTimeout(bootFix3, 400);
  setTimeout(bootFix3, 1200);
  setTimeout(bootFix3, 2500);
  setTimeout(bootFix3, 4500);
  try {
    var mo = new MutationObserver(function () { bootFix3(); });
    mo.observe(document.documentElement, { childList: true, subtree: true });
    setTimeout(function () { try { mo.disconnect(); } catch (e) {} }, 9000);
  } catch (e) {}
})();


/* === FOUNDER FIX4 — brand-selected class on Globo options === */
(function () {
  function markSelected() {
    var root = document.querySelector('.globo-swatch-product-detail');
    if (!root) return;
    root.querySelectorAll('label.globo-style--button, label.swatch-anchor, label.globo-detail-style-circle').forEach(function (lab) {
      lab.classList.remove('v4-brand-selected');
    });
    root.querySelectorAll('li.select-option.selected label.globo-style--button, li.select-option.selected label.swatch-anchor, li.select-option.selected label.globo-detail-style-circle').forEach(function (lab) {
      lab.classList.add('v4-brand-selected');
    });
    root.querySelectorAll('input[type="radio"]:checked + label').forEach(function (lab) {
      lab.classList.add('v4-brand-selected');
    });
  }
  function boot() {
    markSelected();
    var root = document.querySelector('.globo-swatch-product-detail');
    if (root && !root.dataset.v4BrandSel) {
      root.dataset.v4BrandSel = '1';
      root.addEventListener('click', function () { setTimeout(markSelected, 30); });
      root.addEventListener('change', function () { setTimeout(markSelected, 30); });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  setTimeout(boot, 500);
  setTimeout(boot, 1500);
  setTimeout(boot, 3000);
})();


/* === FOUNDER FIX5 — colour value fallback already patched in restoreKiwi syncColour === */


/* === FOUNDER 2026-10-03 — payment heading only.
   Vitals module 15 renders .vtl-pl-main-widget (logos stay).
   Replace its title. Do not touch .v4-trust drawers. */
(function () {
  var NEXT = 'Can I pay the way I want';
  var PREV = 'Secure checkout with your preferred payment method';
  function rename() {
    var nodes = document.querySelectorAll('.vtl-pl-main-widget__title small, .vtl-pl-main-widget__title');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.querySelector && el.querySelector('small')) continue;
      var cur = (el.textContent || '').replace(/\s+/g, ' ').trim();
      if (cur === PREV || (cur.indexOf('Secure checkout with your preferred') !== -1 && cur.length < 80)) {
        el.textContent = NEXT;
      }
    }
  }
  function boot() { rename(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  [400, 900, 1600, 2800, 4500].forEach(function (ms) { setTimeout(rename, ms); });
  var root = document.querySelector('.product__info-container') || document.body;
  if (window.MutationObserver && root) {
    var obs = new MutationObserver(function () { rename(); });
    obs.observe(root, { childList: true, subtree: true });
  }
})();


/* === PDP TRUST FULL WIDTH 2026-10-03 — layout wrap only.
   Moves existing nodes below the gallery + buy grid.
   Does not rewrite copy, logos, drawers, or links. */
(function () {
  function productGrid() {
    var media = document.querySelector('.product__media-wrapper');
    return media ? media.closest('.product') : null;
  }

  function scopeOf(product) {
    if (!product) return document.querySelector('.product__info-container') || document.body;
    return product.closest('.shopify-section') || product.parentElement || document.body;
  }

  function arranged(wrap, pay, trust, share) {
    var kids = [];
    for (var i = 0; i < wrap.children.length; i++) {
      var el = wrap.children[i];
      if (el === pay || el === trust || el === share) kids.push(el);
    }
    if (share) return kids.length === 3 && kids[0] === pay && kids[1] === trust && kids[2] === share;
    return kids.length === 2 && kids[0] === pay && kids[1] === trust;
  }

  function parked(wrap, product) {
    return !!(product && wrap && wrap.parentElement === product.parentElement && wrap.previousElementSibling === product);
  }

  function compress() {
    var product = productGrid();
    var scope = scopeOf(product);
    if (!scope || scope.getAttribute('data-v4-paytrust-lock') === '1') return;

    var trust = null;
    var trusts = scope.querySelectorAll('.v4-trust');
    for (var i = 0; i < trusts.length; i++) {
      if (!trusts[i].closest('[data-v4-trust-drawer]')) { trust = trusts[i]; break; }
    }
    var pay = scope.querySelector('.vtl-pl-main-widget');
    var share = scope.querySelector('share-button');
    if (!trust || !pay) return;

    var wrap = scope.querySelector('.v4-paytrust');
    if (wrap && arranged(wrap, pay, trust, share) && parked(wrap, product)) return;

    scope.setAttribute('data-v4-paytrust-lock', '1');
    try {
      if (!wrap) {
        wrap = document.createElement('div');
        wrap.className = 'v4-paytrust';
      }
      wrap.classList.add('v4-paytrust--full');
      if (pay.parentElement !== wrap) wrap.appendChild(pay);
      if (trust.parentElement !== wrap) wrap.appendChild(trust);
      if (share && share.parentElement !== wrap) wrap.appendChild(share);
      if (product && product.parentElement) product.after(wrap);
    } finally {
      scope.removeAttribute('data-v4-paytrust-lock');
    }
  }

  window.__v4CompressPayTrust = compress;

  function boot() {
    try { compress(); } catch (e) {}
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  [250, 800, 1700, 3200, 5000].forEach(function (ms) { setTimeout(boot, ms); });

  var product = productGrid();
  var root = scopeOf(product);
  if (window.MutationObserver && root) {
    var obs = new MutationObserver(function () { boot(); });
    obs.observe(root, { childList: true, subtree: true });
    setTimeout(function () { try { obs.disconnect(); } catch (e) {} }, 12000);
  }
})();


/* === Collection pill place 2026-10-04 === */
/* Pill removed. Do not move .v4-pdp-collection-pill. */


/* === B1 FIX 2026-10-08 — Globo swatch → theme variant sync for EVERY option position (Hybrid 189753655676 only) ===
   Bug: when Size is option2/3, picking a Globo size changed Globo's UI + URL but not the theme's native
   variant-selects, so the product form kept the first variant id (e.g. XL) and the wrong variant was added.
   Fix: mirror each Globo option into the native fieldset at the same option position and fire Dawn's normal
   change flow; also set the main product form's hidden id to the variant matching the Globo selection
   (immediately, and again on submit as a guard). Idempotent: does nothing when native already matches. */
(function () {
  var variants = null, loading = false;
  function vsEl() {
    return document.querySelector('.product__info-container variant-selects') || document.querySelector('main variant-selects');
  }
  function globoRoot() {
    return document.querySelector('.globo-swatch-product-detail:not([class*="globo-swatch-featured-product"])');
  }
  function mainFormId(vs) {
    var el = vs && vs.querySelector('input[form], select[form]');
    return el ? el.getAttribute('form') : null;
  }
  function globoSelection() {
    var root = globoRoot();
    if (!root) return null;
    var sel = [], any = false;
    root.querySelectorAll('.swatch--gl[data-option-index]').forEach(function (g) {
      var i = parseInt(g.getAttribute('data-option-index'), 10);
      var r = g.querySelector('input[type="radio"]:checked');
      if (!isNaN(i) && r) { sel[i] = r.value; any = true; }
    });
    return any ? sel : null;
  }
  function loadVariants(cb) {
    if (variants) { if (cb) cb(); return; }
    var vs = vsEl(), h = vs && vs.dataset.productHandle;
    if (!h || loading) return;
    loading = true;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'products/' + encodeURIComponent(h) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (p) { variants = (p && p.variants) || null; loading = false; if (cb) cb(); })
      .catch(function () { loading = false; });
  }
  function matchVariant(sel) {
    if (!variants || !sel) return null;
    for (var k = 0; k < variants.length; k++) {
      var v = variants[k], ok = true;
      for (var i = 0; i < sel.length; i++) {
        if (sel[i] != null && v.options[i] !== sel[i]) { ok = false; break; }
      }
      if (ok) return v;
    }
    return null;
  }
  function setFormId(vs, v) {
    var fid = mainFormId(vs);
    if (!fid || !v) return;
    var form = document.getElementById(fid);
    var input = form && form.querySelector('input[name="id"]');
    if (input && String(input.value) !== String(v.id)) {
      input.value = v.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  function syncNative() {
    var vs = vsEl(), sel = globoSelection();
    if (!vs || !sel) return;
    var groups = vs.querySelectorAll('fieldset, .product-form__input--dropdown');
    var last = null;
    for (var i = 0; i < sel.length; i++) {
      if (sel[i] == null || !groups[i]) continue;
      var g = groups[i], val = sel[i], radio = null;
      g.querySelectorAll('input[type="radio"]').forEach(function (x) { if (x.value === val) radio = x; });
      if (radio) {
        if (!radio.checked) { radio.checked = true; last = radio; }
        continue;
      }
      var s = g.querySelector('select');
      if (s && s.value !== val) {
        for (var j = 0; j < s.options.length; j++) {
          if (s.options[j].value === val) { s.value = val; last = s; break; }
        }
      }
    }
    if (last) last.dispatchEvent(new Event('change', { bubbles: true }));
    loadVariants(function () { setFormId(vsEl(), matchVariant(globoSelection())); });
  }
  function later() { setTimeout(syncNative, 0); setTimeout(syncNative, 250); }
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (t && String(t.name || '').indexOf('globo-option') === 0) later();
  });
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t && t.closest && t.closest('.globo-swatch-product-detail .swatch--gl')) later();
  });
  // Guard: the posted id must match the Globo selection on the main product form.
  document.addEventListener('submit', function (e) {
    var f = e.target, vs = vsEl();
    if (!f || !vs || f.id !== mainFormId(vs)) return;
    var v = matchVariant(globoSelection());
    if (!v) return;
    var input = f.querySelector('input[name="id"]');
    if (input && String(input.value) !== String(v.id)) input.value = v.id;
  }, true);
  function boot() { if (vsEl()) loadVariants(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  window.addEventListener('Globo.swatch.loaded', function () { loadVariants(syncNative); });
})();


/* === BET-A 2026-10-17 (Theo) — unpublished 190167122300 only ===
   FIX 1: new-session Vitals "difference" popup is quiet on collection and product pages.
   Live read 17 Oct: it opens ~2 s after landing on every fresh session (mobile bottom sheet,
   page blurred, body scroll locked) and its SHOP NOW sends the shopper to
   /collections/new-arrivals-trendsetting-fashion, away from the collection or product they landed on.
   The offer it carries (20% off £100 + Free UK shipping) is already in the announcement bar.
   Homepage and all other pages keep the popup unchanged. To undo: delete this block and the
   matching CSS block "BET-A FIX 1". */
(function () {
  var p = location.pathname;
  if (!/^\/(collections|products)\//.test(p) && p.indexOf('/products/') === -1) return;
  var root = document.documentElement;
  root.classList.add('v4-quiet-popup');
  function quiet() {
    var box = document.querySelector('#vitals_popup .Vtl-Modal--Active, #vitals_popup dialog[open], #vitals_popup .Vtl-Modal__InnerWrapper--Active');
    if (!box) return;
    var close = document.querySelector('#vitals_popup .Vtl-Popup__CloseButton');
    if (close) close.click();
    if (document.body) document.body.classList.remove('Vtl-Modal--Active');
  }
  function watch() {
    if (!document.body || !window.MutationObserver) return;
    var mo = new MutationObserver(quiet);
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
    setTimeout(function () { mo.disconnect(); }, 60000);
    quiet();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
})();

/* BET-A FIX 2: mobile collection intro "Read more" for the 2-line clamped hook (CSS block "BET-A FIX 2"). */
(function () {
  function init() {
    var btns = document.querySelectorAll('.v4-hook-more');
    for (var i = 0; i < btns.length; i++) {
      (function (btn) {
        var hook = document.getElementById(btn.getAttribute('aria-controls'));
        if (!hook) return;
        if (hook.scrollHeight > hook.clientHeight + 2) btn.hidden = false;
        btn.addEventListener('click', function () {
          var open = hook.classList.toggle('is-open');
          btn.setAttribute('aria-expanded', open ? 'true' : 'false');
          btn.textContent = open ? 'Read less' : 'Read more';
        });
      })(btns[i]);
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
